module.exports = __webpack_public_path__ + "img/INF-i-1-I.95d38a2d.png";